import request from '@/utils/request';
import { stringify } from 'qs';


// 客服信息
export async function getCustomerInfo (params: object) {
  return request(`/api/customer_service/info?${stringify(params)}`, {})
}

